module.exports = __webpack_public_path__ + "6a5985a916a05c61372479b1fd9e417e.png";